import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { resolveRedirectionPath, getLocationFullPath } from '../services';
import { getIsAuthenticated } from '../redux';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const authenticated = useSelector(getIsAuthenticated);

  if (authenticated) {
    return children;
  }

  const redirection = getLocationFullPath();
  const path = resolveRedirectionPath('/login', redirection);

  return <Navigate replace to={path} />;
}

export default memo(ProtectedRoute);
